// src/i18n/pt/views/dominioPropio.js
//
// Traducción al portugués de Brasil de la guía que ve el anfitrión para apuntar
// su dominio a la web del constructor. Misma estructura y mismas claves que la
// versión en español: solo cambian los textos.
//
// Marcadores que rellena la pantalla (no se traducen):
//   {dominio} {destino} {nombre} {tipo} {valor} {encontrado} {actual} {sitio}
//   {panel} {panelCorto} {paso}

export const dominioPropio = {
  cabecera: {
    titulo: "Conecte seu próprio domínio",
    subtitulo:
      "Seu site aparece agora em {actual}. Quando terminar, vai aparecer no seu endereço de sempre.",
    duracion: "Dez minutos do seu tempo. O resto a internet faz sozinha.",
  },

  pasos: {
    uno: "Seu domínio",
    dos: "As duas anotações em {panelCorto}",
    tres: "Verificar",
    unoDetalle: "Você escreve o endereço que quer usar",
    dosDetalle: "Você copia duas linhas no painel do seu domínio",
    tresDetalle: "Nós verificamos se está tudo no lugar",
    indicador: "Passo {paso} de 3",
  },

  paso1: {
    titulo: "Qual endereço você quer para o seu site?",
    descripcion:
      "Escreva o domínio que você já comprou. Nós não vendemos domínios: aqui você conecta um que já é seu.",
    etiqueta: "Seu domínio",
    marcador: "meudominio.com",
    ayuda: "Escreva do jeito que ele é, sem «https://» e sem barras no final.",

    formaTitulo: "E como você quer que ele apareça?",
    formaRaiz: {
      titulo: "meudominio.com",
      descripcion: "O endereço curto, sem nada na frente. É o mais comum.",
    },
    formaWww: {
      titulo: "www.meudominio.com",
      descripcion: "O de sempre, com «www» na frente.",
    },
    formaSubdominio: {
      titulo: "reservas.meudominio.com",
      descripcion:
        "Um endereço separado, para não mexer no site que você já tem em {dominio}.",
    },
    subdominioEtiqueta: "A palavra que vai na frente",
    subdominioMarcador: "reservas",
    subdominioAyuda: "Só a palavra. O resto nós colocamos.",

    avisoWebExistente: {
      titulo: "Você já tem um site nesse endereço?",
      texto:
        "Se {dominio} mostra outro site hoje, quando terminar ele deixa de aparecer e passa a aparecer este. Se você prefere manter o antigo, use um endereço separado, como reservas.{dominio}.",
    },

    boton: "Continuar",
    botonComprobando: "Verificando o domínio…",
  },

  proveedor: {
    pregunta: "Onde você comprou ou gerencia {dominio}?",
    ayuda:
      "É a empresa onde você paga a renovação todo ano. Se não lembrar, procure no seu e-mail a última fatura do domínio.",
    cloudflare: "Cloudflare",
    cloudflareDetalle: "Instruções completas, tela por tela",
    otro: "Outra empresa",
    otroDetalle: "GoDaddy, Registro.br, Locaweb, HostGator…",
    otroTexto:
      "As anotações são exatamente as mesmas. Só muda onde fica o botão. Procure no seu painel alguma coisa escrita «DNS», «Zona DNS» ou «Gerenciar DNS» e copie ali as linhas da tabela de cima, uma por uma.",
    noLoSe: "Não sei",
    noLoSeTexto:
      "Escreva para a gente com o seu domínio e nós dizemos onde ele está e o que precisa mexer.",
  },

  paso2: {
    titulo: "Agora é preciso dizer ao seu domínio onde está o seu site",
    descripcion:
      "Seu domínio é um nome. Sozinho ele não leva a lugar nenhum: alguém precisa anotar num caderno que esse nome corresponde ao nosso servidor. Esse caderno se chama DNS e fica no painel do seu domínio.",

    queEsUnRegistro: {
      titulo: "O que você vai fazer exatamente",
      texto:
        "Você vai acrescentar uma linha nesse caderno. Uma só. Ela tem três campos: como se chama, para onde aponta e se passa ou não por um filtro. Nada mais.",
      textoOtro:
        "Você vai acrescentar linhas nesse caderno. Cada uma tem dois campos: como se chama e para onde aponta. Nada mais.",
    },

    copiaTitulo: "Copie estes dados do jeito que estão",
    copiaAyuda:
      "Use os botões de copiar. Um espaço a mais ou uma letra trocada e não funciona.",

    tabla: {
      tipo: "Tipo",
      nombre: "Nome",
      destino: "Destino",
      contenido: "Conteúdo",
      proxy: "Status do proxy",
      ttl: "TTL",
      valorProxy: "Somente DNS (nuvem cinza)",
      valorTtl: "Auto",
    },

    copiar: "Copiar",
    copiado: "Copiado",
    copiarTodo: "Copiar os dados",

    tipos: {
      cnameTitulo: "CNAME",
      cnameTexto:
        "É um encaminhamento: diz que o seu domínio é atendido em {destino}. Se um dia nós trocarmos de servidor, você não precisa mexer em nada.",
      txtTitulo: "TXT",
      txtTexto:
        "É um bilhete assinado. Não leva a lugar nenhum: só prova que o domínio é seu. Dá para apagar quando o site já estiver funcionando, mas é mais prático deixar ali.",
    },

    nombreTitulo: "O que se escreve em «Nome»",
    nombreRaiz:
      "Para o domínio curto ({dominio}) escreva um arroba: @. No caderno do DNS, o arroba quer dizer «o domínio puro, sem nada na frente». Não escreva {dominio} inteiro.",
    nombreWww: "Para www.{dominio} escreva só: www",
    nombreSubdominio:
      "Para {nombre}.{dominio} escreva só a palavra da frente: {nombre}",
    nombreAviso:
      "No Cloudflare você escreve só essa parte. Ele acrescenta «.{dominio}» sozinho e mostra isso embaixo do campo.",
    nombreAvisoOtro:
      "Em quase todos os painéis se escreve só essa parte e eles acrescentam «.{dominio}». Se o seu pedir o nome inteiro, escreva {nombre}.{dominio}.",
    nombreAvisoOtroRaiz:
      "Se o seu painel não aceitar «@», deixe o nome em branco: em muitos quer dizer a mesma coisa, o domínio sem nada na frente.",

    volver: "Já fiz, voltar para o WACheckin",
    ayudaEnviar: "Enviar estes dados para o meu e-mail",
    ayudaEnviarTexto:
      "Se quem vai fazer é o seu técnico ou quem cuidou do seu site, mandamos as instruções para o seu e-mail para você encaminhar.",
  },

  cloudflare: {
    titulo: "Faça no Cloudflare",
    subtitulo: "Dez minutos. Deixe à mão o e-mail e a senha do Cloudflare.",

    pasos: {
      uno: "Entre em dash.cloudflare.com com a sua conta.",
      dos: "Na primeira tela aparecem os seus domínios. Clique em {dominio}.",
      tres:
        "No menu da esquerda abra «DNS» e depois «Registros» («Records»).",
      cuatro:
        "Você vai ver uma lista com as linhas que já existem. Clique no botão «Adicionar registro» («Add record»).",
      cinco: "Em «Tipo» («Type») escolha {tipo} na lista.",
      seis: "Em «Nome» («Name») escreva {nombre}",
      siete: "Em «Destino» («Target») cole {valor}",
      ocho:
        "Em «Status do proxy» («Proxy status») clique na nuvem laranja. Ela tem que ficar cinza e mostrar «Somente DNS» («DNS only»).",
      nueve: "Deixe «TTL» em «Auto». Não mexa nisso.",
      diez: "Clique em «Salvar» («Save»).",
      once:
        "Se a tabela de cima tiver mais de uma linha, repita a partir do passo 4 com a próxima.",
    },

    hecho: "Pronto. Volte para o WACheckin e clique em «Verificar».",

    avisoAntes: {
      titulo: "Antes de salvar, leia isto",
      texto:
        "O Cloudflare deixa essa nuvem laranja sozinho, sem perguntar. Se você deixar laranja, a conexão não vai funcionar. O passo 8 é o mais importante desta tela.",
    },

    accesoNegado: {
      titulo: "Não consegue entrar no Cloudflare?",
      texto:
        "A conta costuma estar no nome de quem montou o seu site. Peça para essa pessoa fazer estes passos ou incluir você como membro do domínio.",
    },
  },

  proxy: {
    titulo: "A nuvem laranja: é isto que dá errado sempre",
    queEs:
      "Ao lado de cada linha do DNS, o Cloudflare mostra uma nuvenzinha. Laranja quer dizer que o tráfego passa antes pelo Cloudflare. Cinza quer dizer que vai direto.",
    porQueFalla:
      "Com a nuvem laranja, quando alguém pergunta pelo seu domínio o Cloudflare não responde {destino}: responde com os endereços dele. A nossa verificação pergunta, vê o Cloudflare e não encontra a anotação que pedimos. Mesmo você tendo escrito certo, para nós é como se ela não existisse.",
    porQueFalla2:
      "E tem uma segunda consequência, pior: o cadeado de segurança do seu site é emitido conferindo que o domínio chega até nós. Com a nuvem laranja ele não chega, então não dá para emitir e o navegador vai avisar que o site não é seguro.",
    comoSeArregla:
      "Clique na nuvem. Ela fica cinza e o texto do lado muda para «Somente DNS» («DNS only»). Salve. É só isso.",
    grisEsSeguro:
      "Deixar cinza não desprotege o seu site. Quem serve o seu site somos nós, com certificado próprio e atrás da nossa proteção. O Cloudflare estava no meio só porque já vinha assim de fábrica.",
    ttlBloqueado:
      "Um detalhe que confunde muita gente: enquanto a nuvem está laranja, o Cloudflare não deixa mexer no TTL. Quando ela fica cinza, libera. Deixe em «Auto».",
    etiquetaProxied: "Com proxy («Proxied»), nuvem laranja: NÃO",
    etiquetaSoloDns: "Somente DNS («DNS only»), nuvem cinza: SIM",
  },

  raiz: {
    titulo: "Se você usa o domínio curto: não precisa fazer nada especial",
    texto:
      "Existe uma regra antiga da internet que diz que o domínio curto ({dominio}, sem nada na frente) não aceita esse tipo de anotação. Na maioria das empresas isso obriga a dar voltas.",
    flattening:
      "O Cloudflare resolve sozinho. Quando o «Nome» é @, ele aplica um recurso próprio chamado CNAME flattening: guarda o seu encaminhamento e, quando alguém pergunta, já responde com o endereço final. Você não precisa ativar nada, já vem ligado em todos os planos, inclusive no gratuito.",
    avisoAjusteGlobal:
      "O que vale a pena: não mexa na opção «CNAME flattening for all CNAME records», em «DNS» → «Configurações» («Settings»). Aplicada a tudo, ela deixa de responder os encaminhamentos do jeito que estão escritos e quebra as verificações de propriedade de outros serviços que você tenha: e-mail, Google, a loja…",
    tituloOtro: "Se você usa o domínio curto ({dominio})",
    textoOtroA:
      "No domínio sem nada na frente entram linhas do tipo A, as da tabela. Todas as empresas aceitam.",
    textoOtroCname:
      "Muitas empresas não deixam colocar um CNAME no domínio sem nada na frente. Se a sua não deixar salvar essa linha, use «www» ou um endereço separado, como reservas.{dominio}, ou escreva para a gente que resolvemos junto com você.",
    conflicto: {
      titulo: "Se o domínio curto já tinha alguma coisa",
      texto:
        "Um mesmo nome não pode ter dois destinos ao mesmo tempo. Se na lista já existe uma linha do tipo A ou CNAME com o «Nome» em @ (ou em «www», se você vai usar www), apague antes de acrescentar a nossa. O Cloudflare avisa se você não fizer isso.",
      textoOtro:
        "Um mesmo nome não pode ter dois destinos ao mesmo tempo. Se no seu painel já existe uma linha do tipo A ou CNAME com esse mesmo nome, apague antes de acrescentar a nossa.",
      comoBorrar:
        "Passe o mouse por cima dessa linha, clique em «Editar» («Edit») e depois em «Excluir» («Delete»).",
      apunta:
        "Anote num papel o que estava escrito antes de apagar, caso precise voltar atrás.",
    },
  },

  propagacion: {
    titulo: "Quanto tempo demora para aparecer?",
    texto:
      "O Cloudflare publica a mudança na hora. O que demora é o resto da internet ficar sabendo: cada computador guarda uma cópia do caderno por um tempo para não perguntar mil vezes.",
    plazoNormal:
      "Com o TTL em «Auto», o Cloudflare pede que essa cópia dure cinco minutos. Na prática, o normal é funcionar entre cinco e trinta minutos depois de salvar.",
    textoOtro:
      "O seu painel publica a mudança em alguns minutos. O que demora é o resto da internet ficar sabendo: cada computador guarda uma cópia do caderno por um tempo para não perguntar mil vezes.",
    plazoNormalOtro:
      "O normal é funcionar entre dez minutos e uma hora depois de salvar. Algumas empresas demoram mais para publicar a mudança: conte com até 24 horas antes de se preocupar.",
    plazoMalo:
      "Se o seu domínio já mostrava outro site, o seu próprio computador pode demorar mais para soltar o que tinha guardado. Não é um erro. Conte com 24 horas antes de se preocupar.",
    truco:
      "Dica para não ficar maluco olhando: abra numa janela anônima, ou pelo celular usando os dados em vez do wi-fi. Assim você vê o que um cliente novo vê, não o que o seu computador guardou.",
    dominioNuevo:
      "Fora isso: se você acabou de acrescentar o domínio no Cloudflare pela primeira vez, ele demora até 24 horas para dar o domínio como ativo. Até lá tudo funciona como se as nuvens estivessem cinzas, mesmo que você as veja laranjas. Espere o domínio mostrar «Ativo» («Active») antes de achar que algo deu errado.",
    ssl:
      "Quando a verificação der certo, nós emitimos o cadeado de segurança. Isso leva mais alguns minutos. Até terminar, o navegador pode avisar que o site não é seguro: é normal e passa sozinho.",
  },

  paso3: {
    titulo: "Vamos verificar",
    descripcion:
      "Nós olhamos o seu domínio e dizemos o que encontramos. Se faltar alguma coisa, dizemos o que é e como resolver.",
    boton: "Verificar agora",
    botonReintentar: "Verificar de novo",
    comprobando: "Olhando os seus registros…",
    comprobandoAyuda: "Leva alguns segundos.",

    resultado: {
      registroOk: "A anotação do DNS está feita e aponta para nós",
      registroKo: "Ainda não vemos a anotação",
      proxyOk: "A nuvem está cinza, como tem que estar",
      proxyKo: "A nuvem está laranja",
      sslOk: "Cadeado de segurança emitido",
      sslPendiente: "Emitindo o cadeado de segurança…",
      webOk: "Seu site abre em {dominio}, com cadeado",
      webActivando: "Estamos ativando o seu site no seu domínio, com o cadeado de segurança",
      webDespues: "Depois verificamos se o seu site abre, com cadeado",
    },

    activando: {
      titulo: "Seu domínio já aponta certo. Estamos ativando o seu site",
      texto:
        "Só falta o cadeado de segurança, que é emitido sozinho e costuma levar um ou dois minutos. Não mude nada em {panel}: nós verificamos e aqui você vê quando estiver pronto.",
    },

    exito: {
      titulo: "Pronto, o seu site já está em {dominio}",
      texto:
        "Você pode escrever o endereço no navegador e ver. O endereço antigo {actual} continua funcionando, então os links que você já tinha espalhado não quebram.",
      verWeb: "Ver meu site",
      soloWww: "O teu site abre no endereço com «www». Se também quiseres que funcione sem «www», pede ao teu fornecedor de domínio um redirecionamento para o endereço com «www», ou um registo ALIAS/ANAME na raiz se o painel o permitir.",
      copiarEnlace: "Copiar o endereço",
      siguiente: "Agora coloque esse endereço nos seus perfis do Booking, Airbnb, Instagram e na assinatura do seu e-mail.",
    },

    pendiente: {
      titulo: "Ainda não está pronto, e isso é normal",
      texto:
        "Se você acabou de salvar em {panel}, espere alguns minutos e clique de novo. Não precisa ficar aqui: avisamos por e-mail assim que estiver pronto.",
      avisarme: "Me avisar por e-mail quando estiver pronto",
    },
  },

  estados: {
    sinConectar: "Não conectado",
    pendiente: "Esperando as anotações",
    comprobando: "Verificando",
    emitiendoSsl: "Emitindo o cadeado",
    activo: "Funcionando",
    error: "Com um erro",
    activoAyuda: "Seu site aparece em {dominio} e a conexão é segura.",
    activandoAyuda: "Seu domínio já aponta certo. Em alguns minutos o seu site vai abrir em {dominio}, com cadeado.",
  },

  errores: {
    formatoInvalido: {
      titulo: "Isso não parece um domínio",
      texto: "Escreva assim: meudominio.com. Sem espaços e sem mais nada.",
    },
    conProtocolo: {
      titulo: "O «https://» está sobrando",
      texto: "Tire e deixe só o nome: {dominio}",
    },
    conRuta: {
      titulo: "Está sobrando tudo o que vem depois da barra",
      texto: "Deixe só a parte da frente: {dominio}",
    },
    sinExtension: {
      titulo: "Está faltando a terminação",
      texto: "Um domínio termina em .com, .com.br, .net… Confira se não ficou faltando pedaço.",
    },
    dominioNoExiste: {
      titulo: "Esse domínio não existe",
      texto:
        "Não há ninguém registrado com esse nome. Confira se está escrito certo. Se você acabou de comprar, espere algumas horas e tente de novo.",
    },
    dominioCaducado: {
      titulo: "Esse domínio parece vencido",
      texto:
        "Entre na empresa onde você comprou e confira se a renovação está paga. Enquanto estiver vencido não dá para conectar.",
    },
    yaUsadoOtraCuenta: {
      titulo: "Esse domínio já está conectado a outra conta",
      texto:
        "Um domínio só pode apontar para um lugar de cada vez. Se {dominio} é seu, escreva para a gente que desconectamos da outra conta para você poder usar aqui.",
      contactar: "Falar com o suporte",
    },
    yaUsadoEstaCuenta: {
      titulo: "Ele já está conectado",
      texto:
        "{dominio} está em uso em «{sitio}». Desconecte de lá ou escolha outro endereço para este site.",
    },
    registrosNoAparecen: {
      titulo: "Ainda não vemos nada no seu domínio",
      texto:
        "Costuma ser questão de minutos: você acabou de salvar e ainda não chegou a todo lugar. Espere dez minutos e clique em «Verificar» de novo.",
      repasa: "Se já passou meia hora, confira três coisas em {panel}:",
      repasa1: "Se em «Nome» você colocou {nombre} e não o domínio inteiro.",
      repasa2: "Se você clicou em «Salvar» («Save») e a linha aparece na lista.",
      repasa3: "Se você escreveu em {dominio} e não em outro domínio da sua conta.",
    },
    proxyActivado: {
      titulo: "A nuvem laranja está ligada",
      texto:
        "Vemos o seu domínio, mas ele passa pelo proxy do Cloudflare e isso esconde de nós o destino real. Enquanto estiver laranja, nem a verificação nem o cadeado de segurança funcionam.",
      solucion:
        "Entre em «DNS» → «Registros», procure a linha com o nome {nombre}, clique na nuvem laranja até ela ficar cinza e mostrar «Somente DNS» («DNS only»), e salve. Depois volte e clique em «Verificar».",
    },
    apuntaOtroSitio: {
      titulo: "Seu domínio aponta para outro lugar",
      texto:
        "Encontramos {encontrado} e esperávamos {destino}. Quase sempre é uma anotação antiga do site anterior que ficou ali.",
      solucion:
        "Em «DNS» → «Registros», apague a linha antiga que tem o nome {nombre} e deixe só a nossa.",
    },
    destinoAntiguo: {
      titulo: "O valor que demos antes não funcionava",
      texto:
        "Sua anotação leva para {encontrado}, que foi o que indicamos, mas esse endereço não funciona. O erro foi nosso, não seu.",
      solucion: "Em {panel}, edite a anotação {nombre} e coloque como valor {destino}. O TXT deixe como está.",
    },
    registroDuplicado: {
      titulo: "Há duas anotações para o mesmo nome",
      texto:
        "Um nome não pode levar para dois lugares. Apague a que não for a nossa e verifique de novo.",
    },
    error1014: {
      titulo: "Se o navegador mostrar «Error 1014»",
      texto:
        "É outra cara do mesmo problema de sempre: a nuvem laranja. Deixe cinza («Somente DNS») e ele some.",
    },
    sslFallido: {
      titulo: "Não conseguimos emitir o cadeado de segurança",
      texto:
        "A anotação do DNS está certa, mas o cadeado não sai. Costuma ser a nuvem laranja de novo, ou uma anotação antiga que atrapalha. Tente de novo daqui a pouco; se continuar igual, escreva para a gente que nós olhamos.",
      reintentar: "Tentar emitir de novo",
    },
    sinPermisos: {
      titulo: "Você não pode mudar o domínio",
      texto: "Peça isso ao responsável pela conta.",
    },
    servidor: {
      titulo: "Não conseguimos verificar agora",
      texto: "Alguma coisa falhou do nosso lado. Tente em alguns minutos.",
    },
    guardar: "Não foi possível salvar o domínio. Tente de novo.",
  },

  desconectar: {
    boton: "Desconectar este domínio",
    titulo: "Desconectar {dominio}?",
    texto:
      "Seu site vai deixar de aparecer em {dominio} e volta a aparecer só em {actual}. Quem escrever o seu domínio não vai encontrar nada até você apontar o domínio para outro lugar.",
    aviso: "As anotações que você fez em {panel} continuam lá. Apague você mesmo se não quiser mais.",
    cancelar: "Cancelar",
    confirmar: "Desconectar",
    hecho: "Domínio desconectado.",
  },

  dudas: {
    titulo: "Dúvidas que aparecem sempre",

    correoPregunta: "Isso vai derrubar o e-mail do @{dominio}?",
    correoTexto:
      "Não. O e-mail passa por outras linhas do caderno, as do tipo MX, e nós não mexemos nelas. Enquanto você não apagar essas, o seu e-mail continua igual.",

    otraWebPregunta: "Tenho outro site nesse domínio. O que acontece com ele?",
    otraWebTexto:
      "Ele deixa de aparecer: o domínio passa a mostrar este. Se quiser manter os dois, use um endereço separado, como reservas.{dominio}, para o site do WACheckin.",

    volverAtrasPregunta: "Posso voltar atrás?",
    volverAtrasTexto:
      "Sim, quando quiser. Desfaz no mesmo lugar onde foi feito: você apaga a anotação em {panel} e coloca de volta a que tinha antes. Demora o mesmo tanto para aparecer, alguns minutos.",

    wwwPregunta: "Vai funcionar com e sem «www»?",
    wwwTexto:
      "Sim, se você colocar as duas linhas que damos. Uma é a principal e a outra encaminha para ela, para o Google não ver dois sites iguais.",

    costePregunta: "Isso tem algum custo?",
    costeTexto:
      "Conectar, não. O domínio você continua pagando onde comprou, como até agora.",

    quienPregunta: "Não me sinto capaz de fazer isso.",
    quienTexto:
      "Normal, é a parte mais chata de todo o processo. Escreva para a gente com o seu domínio e deixamos tudo pronto junto com você, por telefone, em dez minutos.",
  },

  botones: {
    atras: "Voltar",
    siguiente: "Avançar",
    guardar: "Salvar",
    guardando: "Salvando…",
    cerrar: "Fechar",
    entendido: "Entendi",
    abrirCloudflare: "Abrir o Cloudflare",
    soporte: "Quero ajuda do WACheckin",
    verGuia: "Ver o guia de novo",
  },

  avisos: {
    copiado: "Copiado para a área de transferência",
    copiadoError: "Não foi possível copiar. Selecione na mão.",
    guardado: "Domínio salvo. Agora é hora de fazer as anotações em {panel}.",
    conectado: "Seu site já aparece em {dominio}!",
    correoEnviado: "Mandamos as instruções para o seu e-mail.",
  },
};
